<h5 class="fw-bold">
  <span class="text-muted me-2">{{ order }}</span>
  <span class="underline">{{ underlineString }}</span
  >{{ normalString }}
</h5>
